module.exports = (text, branding, linkPath) => {
  return `<mj-button
    color="#ffffff"
    inner-padding="18px 40px"
    font-size="20px"
    font-family="${branding.headerFont || 'Arial'}"
    border-radius="29px"
    href="{{defaults @root.company.domain.domain 'http://localhost:8080'}}${linkPath || ''}"
    background-color="${branding.primaryColour || '#888888'}"
  >
    <b>${text}</b>
  </mj-button>`;
};


// WEBPACK FOOTER //
// ./src/emails/components/button.js